var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":"Device infomation","visible":_vm.visible,"footer":false},on:{"cancel":_vm.changeVisible}},[_c('a-table',{attrs:{"data-test":"table","rowKey":"id","columns":_vm.columns,"data-source":_vm.deviceList,"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }